/* File: src/contexts/game/gameCloudFunctions.js */
import { functions } from '../../firebaseConfig'; // Import your Firebase app instance (ensure functions is initialized)
import { httpsCallable } from 'firebase/functions';

// --- Define the callable function reference ---
// Replace 'generateSequence' with the EXACT name you exported
// from your functions/index.js for the sequence generator.
// Check functions/game.js or functions/index.js if unsure. It might be 'generateGameSequence' etc.
let generateSequenceCallable;
try {
    generateSequenceCallable = httpsCallable(functions, 'generateSequence');
    console.log("[gameCloudFunctions] 'generateSequence' callable obtained.");
} catch (error) {
    console.error("[gameCloudFunctions] Failed to get 'generateSequence' callable function.", error);
    // Handle the error appropriately, maybe set generateSequenceCallable to null or throw
}

/**
 * Frontend wrapper function to call the backend 'generateSequence' Cloud Function.
 * @param {object} data - The data payload to send to the backend function.
 * @param {number} data.nBack - The n-back level.
 * @param {number} data.difficulty - The difficulty level (0.0-0.95 or 0.0-1.0 depending on backend).
 * @param {boolean} data.isPlayground - True if it's a playground session.
 * @param {boolean} data.isChallengeAttempt - True if it's a challenge attempt.
 * @param {string|null} data.profileId - The user's profile ID (can be null for playground).
 * @param {object|null} [data.playgroundParams] - Specific parameters for playground mode.
 * @returns {Promise<object>} A promise that resolves with the backend response object
 *                            (containing sequence, parameters, matches, etc.).
 * @throws {Error} Throws an error if the backend call fails or the callable wasn't initialized.
 */
export const generateSequenceHttp = async (data) => {
    console.log("[generateSequenceHttp] Calling backend with data:", data);
    if (!generateSequenceCallable) {
        console.error("[generateSequenceHttp] Cannot call backend: callable function reference is not available.");
        throw new Error("Sequence generation service unavailable.");
    }

    try {
        const result = await generateSequenceCallable(data);
        console.log("[generateSequenceHttp] Received response from backend:", result.data);
        // The callable function result has the data nested under a 'data' property
        return result.data;
    } catch (error) {
        console.error("[generateSequenceHttp] Backend function call failed:", error);
        // Rethrow or handle the error more gracefully
        throw new Error(`Failed to generate sequence: ${error.message}`);
    }
};

// You might add other game-related cloud function wrappers here later.